/* Campsite card embeds — hydrate inline markers in article bodies.
 *
 * Usage in article HTML (bloggle editor or any liquid block):
 *   <div data-campsite-id="123"></div>            single card by entity ID
 *   <div data-campsite-slug="lucky-bay"></div>    single card by slug
 *   <div data-campsite-state="WA" data-limit="4"></div>   row of cards filtered to state
 *
 * Renders into the existing .campsite-card markup so styling matches the
 * bottom Campsite Recommendations band. Safe to load on any page — does
 * nothing if no markers are present.
 */
(function () {
  if (window.__campsiteCardEmbedLoaded) return;
  window.__campsiteCardEmbedLoaded = true;

  var API_BASE = 'https://app.trip-planner.com.au/api';
  var EXPLORER_BASE = '/apps/campsite-explorer';
  var IMG_PROXY = 'https://jola-888.imgix.net';
  var PLACEHOLDER_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">' +
    '<path d="M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"/></svg>';

  function buildImg(src, name) {
    if (!src || src === '/' || !src.trim()) {
      return '<div class="campsite-card__placeholder">' + PLACEHOLDER_SVG + '<span>Campsite</span></div>';
    }
    var url = /^https?:\/\//i.test(src)
      ? src
      : src.charAt(0) === '/'
        ? IMG_PROXY + src + '?w=400&h=260&fit=crop&auto=format'
        : src;
    return '<img src="' + url + '" alt="' + (name || '').replace(/"/g, '&quot;') +
      '" loading="lazy" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\';" />' +
      '<div class="campsite-card__placeholder" style="display:none;">' + PLACEHOLDER_SVG + '<span>Campsite</span></div>';
  }

  function renderCard(site) {
    var url = site.url && site.url.indexOf('undefined') === -1
      ? site.url
      : (site.slug ? EXPLORER_BASE + '/camp-sites/' + site.slug : EXPLORER_BASE);
    var card = document.createElement('a');
    card.href = url;
    card.className = 'campsite-card';
    card.setAttribute('aria-label', 'View ' + (site.name || 'campsite'));
    card.innerHTML =
      '<div class="campsite-card__img-wrap">' + buildImg(site.image_src, site.name) + '</div>' +
      '<div class="campsite-card__body">' +
        '<h3 class="campsite-card__name">' + (site.name || '') + '</h3>' +
        '<p class="campsite-card__location">📍 ' +
          (site.town || '') + (site.town && site.state ? ', ' : '') + (site.state || '') +
        '</p>' +
        '<div class="campsite-card__view-link">View campsite →</div>' +
      '</div>';
    return card;
  }

  function fetchJson(path) {
    return fetch(API_BASE + path).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function getStateFromEntity(e) {
    return (e.addresses && e.addresses[0] && e.addresses[0].state) ||
           e.state || '';
  }

  function hasUsableImage(ent) {
    var s = ent && ent.image_src;
    return !!(s && typeof s === 'string' && s.trim() && s !== '/');
  }

  /* ── Single entity by id ── */
  function hydrateSingleById(node, id) {
    fetchJson('/entities/' + encodeURIComponent(id))
      .then(function (data) {
        var ent = data.entity || data;
        if (!ent || !ent.id) { node.style.display = 'none'; return; }
        /* Skip rendering if the entity has no usable image — placeholders look bad in editorial */
        if (!hasUsableImage(ent)) { node.style.display = 'none'; return; }
        node.classList.add('campsite-card-embed', 'campsite-card-embed--single');
        node.innerHTML = '';
        node.appendChild(renderCard(ent));
      })
      .catch(function () { node.style.display = 'none'; });
  }

  /* ── Single entity by slug ── */
  function hydrateSingleBySlug(node, slug) {
    fetchJson('/entities/by-slug/' + encodeURIComponent(slug))
      .then(function (data) {
        var ent = data.entity || data;
        if (!ent || !ent.id) {
          /* fallback: search the random pool for a slug match */
          return fetchJson('/entities/random?limit=200&product_type=tent').then(function (rd) {
            var items = rd.campsites || rd.entities || [];
            return items.find(function (s) { return s.slug === slug; });
          });
        }
        return ent;
      })
      .then(function (ent) {
        if (!ent || !hasUsableImage(ent)) { node.style.display = 'none'; return; }
        node.classList.add('campsite-card-embed', 'campsite-card-embed--single');
        node.innerHTML = '';
        node.appendChild(renderCard(ent));
      })
      .catch(function () { node.style.display = 'none'; });
  }

  /* ── Row filtered by state ── */
  function hydrateStateRow(node, state, limit) {
    var n = parseInt(limit, 10) || 4;
    /* product_type=tent restricts results to actual campsites/caravan parks
       rather than tour companies, holiday rentals or motels. State filter is
       client-side because the API doesn't filter by state server-side.
       Filter further to entities with usable images so we don't render
       placeholder-only cards (looks bad in editorial). */
    fetchJson('/entities/random?limit=200&product_type=tent')
      .then(function (data) {
        var items = data.campsites || data.entities || [];
        var stUpper = state.toUpperCase();
        var matched = items.filter(function (e) {
          return getStateFromEntity(e).toUpperCase() === stUpper && hasUsableImage(e);
        }).slice(0, n);
        if (!matched.length) { node.style.display = 'none'; return; }
        node.classList.add('campsite-card-embed', 'campsite-card-embed--row');
        node.innerHTML = '';
        var grid = document.createElement('div');
        grid.className = 'campsite-recs__grid';
        matched.forEach(function (s) { grid.appendChild(renderCard(s)); });
        node.appendChild(grid);
      })
      .catch(function () { node.style.display = 'none'; });
  }

  function init() {
    document.querySelectorAll('[data-campsite-id]').forEach(function (n) {
      var v = n.getAttribute('data-campsite-id');
      if (v) hydrateSingleById(n, v);
    });
    document.querySelectorAll('[data-campsite-slug]').forEach(function (n) {
      var v = n.getAttribute('data-campsite-slug');
      if (v) hydrateSingleBySlug(n, v);
    });
    document.querySelectorAll('[data-campsite-state]').forEach(function (n) {
      var s = n.getAttribute('data-campsite-state');
      var l = n.getAttribute('data-limit');
      if (s) hydrateStateRow(n, s, l);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
